import { ReactElement, ReactNode } from 'react';

import { Button, ButtonProps } from '@components/button';
import { IconProps } from '@components/icons';
import { Modal, useModal } from '@components/modal';
import { ModalVariant, SimpleHeaderProps, hideModal } from '@components/modal/modal';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';

export type InfoModalProps = {
  title: SimpleHeaderProps['title'];
  headerIcon?: SimpleHeaderProps['icon'];
  children?: ReactNode;
  buttonText?: string;
  buttonIcon?: ReactElement<IconProps>;
  buttonVariant?: ButtonProps['variant'];
};

export const useInfoModal = (variant?: ModalVariant) =>
  useModal(InfoModal, { variant: variant ?? 'REGULAR' });

const InfoModal = ({
  title,
  headerIcon,
  children,
  buttonText,
  buttonIcon,
  buttonVariant = 'secondary',
}: InfoModalProps) => {
  const { t } = useScopedTranslate();

  return (
    <Modal>
      <Modal.SimpleHeader title={title} icon={headerIcon} />
      <Modal.Content>{children}</Modal.Content>
      <Modal.Footer>
        <Stack orientation="horizontal" space={4} justify="flex-end">
          <Button
            onClick={hideModal}
            variant={buttonVariant}
            iconLeft={buttonIcon ?? <></>}
            text={buttonText ?? t('core.close')}
          />
        </Stack>
      </Modal.Footer>
    </Modal>
  );
};
